import { useState } from "react";
import { socials } from "@/mocks/blog";

export default function SubscribeSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    // anti-spam honeypot
    const honey = (data.get("company_alt") as string) || "";
    if (honey.trim() !== "") {
      setStatus("success");
      setMessage("已收到你的订阅意向，请留意查收邮件～");
      form.reset();
      return;
    }

    const payload = new FormData();
    const mail = data.get("email") as string;
    if (mail) payload.append("email", mail);

    setStatus("loading");
    setMessage("正在提交，请稍候…");
    try {
      const response = await fetch("https://readdy.ai/api/form/daftrkbep053ijub1va0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = (parsed?.meta as Record<string, unknown>)?.message;
      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage(typeof serverMsg === "string" && serverMsg ? serverMsg : "订阅成功，新文章会第一时间推送到你的邮箱！");
        form.reset();
      } else {
        setStatus("error");
        const detail = (parsed?.meta as Record<string, unknown>)?.detail;
        setMessage(
          typeof detail === "string" && detail
            ? detail
            : typeof serverMsg === "string" && serverMsg
              ? serverMsg
              : "提交失败，请稍后重试或检查邮箱格式。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-primary-100/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="relative mx-auto w-full max-w-4xl px-4 py-14 text-center md:px-6 md:py-20">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/30">
          <i className="ri-mail-send-line text-2xl" aria-hidden="true"></i>
        </span>
        <h2 className="mt-6 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
          订阅「吾爱吃瓜」· <span className="text-primary-600">不错过每一次吃瓜现场</span>
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          每周新观点、新随笔第一时间送达。无广告、不打扰，想退订随时可以。你的邮箱，只用来装好内容。
        </p>

        <form
          data-readdy-form="订阅吾爱吃瓜资讯"
          onSubmit={handleSubmit}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
        >
          <div className="relative flex-1">
            <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" aria-hidden="true"></i>
            <input
              type="email"
              name="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {status === "loading" ? "提交中…" : "立即订阅"}
          </button>
        </form>

        {/* honeypot, hidden via CSS class */}
        <div className="hp-field" aria-hidden="true">
          <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" readOnly />
        </div>

        {status === "success" && (
          <p className="mx-auto mt-4 max-w-lg rounded-md bg-accent-100 px-4 py-2.5 text-sm text-accent-800">
            <i className="mr-1 ri-checkbox-circle-line" aria-hidden="true"></i>
            {message}
          </p>
        )}
        {status === "error" && (
          <p className="mx-auto mt-4 max-w-lg rounded-md bg-primary-100 px-4 py-2.5 text-sm text-primary-800">
            <i className="mr-1 ri-error-warning-line" aria-hidden="true"></i>
            {message}
          </p>
        )}

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <span className="text-sm text-foreground-500">关注我的更多动态：</span>
          {socials.map((s) => (
            <a
              key={s.label}
              href="mailto:about@wuaichigua.example"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:bg-primary-500 hover:text-background-50"
              aria-label={s.label}
              title={s.label}
              rel="nofollow noopener"
            >
              <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}